<template>
  <div class="profileView">
    <v-container class="custom-container custom-responsive-height">
      <v-row dense>
        <v-col cols="12">
          <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'" class="my-profile">
            <v-card-actions class="pl-5 align-start py-1">
              <v-icon class="mt-4" color="#708AA7">mdi mdi-account-check-outline</v-icon>
              <v-card-text class="px-0 py-0">
                <v-card-title class="pending-text">Verification Pending</v-card-title>
                <v-card-subtitle>Verification Status</v-card-subtitle>
              </v-card-text>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card class="verification-card" flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'">
            <v-card-actions class="justify-space-between px-0">
              <v-card-title class="pl-1">
                <v-icon class="pr-5" color="#708AA7">mdi mdi-account-outline</v-icon>Identity Verification
              </v-card-title>
              <v-dialog transition="scale-transition" origin="center center" max-width="554"
                content-class="deposit-withdraw-popup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile text elevation="0" class="text-capitalize link text-decoration-underline" color="#5f7692"
                    v-bind="attrs" v-on="on">Detail</v-btn>
                </template>
                <template v-slot:default="dialog">
                  <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                    <v-card-title class="rounded-0">Identity Verification</v-card-title>
                    <v-card-text>
                      To complete the identity verification process, kindly provide colour, high-resolution scans or
                      images of a document with your entire name, picture, signature, birthdate, and expiration date.
                      The application must be submitted on or before the date of the document's validity, and all
                      information must be easily readable.

                      Conditions for Uploading Documents

                      All clients must finish a verification process as part of Forex CRM's compliance with AML
                      (Anti-Money Laundering) regulations. Verified clients are free to use any available way to deposit
                      money into their trading accounts or withdraw monies, without any limitations.

                      In order to authenticate your identity and address, kindly provide a colour photo or a scanned
                      copy of one of these documents:

                      domestic passport (IC, ID)
                      overseas passport
                      A driver's license
                      receipt for a utility bill
                      Statement from the bank
                      All required paperwork must be colour, high-resolution scans or images with a minimum of six
                      months remaining on the validity date. These images or scans must clearly show your full name,
                      photo, signature, date of birth, and expiration date. Make sure the picture displays the
                      document's four edges.
                    </v-card-text>
                  </v-card>
                </template>
              </v-dialog>
            </v-card-actions>

            <v-card-subtitle class="text-center">
              <span class="d-block">Upload: local passport (ID, IC)</span>
              or international passport or driver's license.
            </v-card-subtitle>
            <v-card-text class="text-center">
              <vue-dropzone ref="identityVerification" id="customdropzone" :options="dropzoneOptions"
                @vdropzone-success="identityVerificationFileUpload"></vue-dropzone>
              <div class="dropzone-content">
                <v-icon large class="mb-3" color="#708AA7">mdi mdi-tray-arrow-up</v-icon>
                <p class="mb-0">Drop File Here or <strong>Browse</strong></p>
                <span>File size max 2MB</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card class="verification-card" flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'">
            <v-card-actions class="justify-space-between px-0">
              <v-card-title class="pl-1">
                <v-icon class="pr-5" color="#708AA7">mdi mdi-home-lightning-bolt-outline</v-icon>Residence Verification
              </v-card-title>
              <v-dialog transition="scale-transition" origin="center center" max-width="554"
                content-class="deposit-withdraw-popup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile text elevation="0" class="text-capitalize link text-decoration-underline" color="#5f7692"
                    v-bind="attrs" v-on="on">Detail</v-btn>
                </template>
                <template v-slot:default="dialog">
                  <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                    <v-card-title class="rounded-0">Residence Verification</v-card-title>
                    <v-card-text>
                      Please submit colour, high-resolution scans or pictures of a document with your complete name and
                      address on it as proof of residency; the details must match those in your profile. The material
                      must be released no later than three months before the deadline for submission.

                      Upload Requirements for Documents

                      To ensure compliance with AML (Anti-Money Laundering) regulations, Forex CRM mandates that all of
                      its clients undergo a verification process. Clients that have undergone verification are free to
                      use any available means to withdraw money and deposit it into their trading accounts.

                      Please upload a colour photo or a scanned copy of one of the following papers to help us verify
                      your identity and address:

                      Passport local (ID, IC)
                      foreign passport
                      Licence to drive
                      Receipt of utility bill
                      a bank statement
                      Each document must be a high-resolution colour scan or photo with a validity period of at least
                      six months that clearly shows your full name, photo, signature, date of birth, and expiration
                      date. Make sure the image captures the document's four edges.
                    </v-card-text>
                  </v-card>
                </template>
              </v-dialog>
            </v-card-actions>

            <v-card-subtitle class="text-center">
              <span class="d-block">Upload: local passport (ID, IC)</span>
              or international passport or driver's license.
            </v-card-subtitle>
            <v-card-text class="text-center">
              <vue-dropzone ref="residenceVerification" id="customdropzone" :options="dropzoneOptions"
                @vdropzone-success="residenceVerificationFileUpload"></vue-dropzone>
              <div class="dropzone-content">
                <v-icon large class="mb-3" color="#708AA7">mdi mdi-tray-arrow-up</v-icon>
                <p class="mb-0">Drop File Here or <strong>Browse</strong></p>
                <span>File size max 2MB</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'" class="listing-upload">
            <v-row no-gutters justify="space-between" align="center">
              <v-col cols="4">
                <v-card-title>Date & Time</v-card-title>
                <v-card-subtitle>10/12-10:22pm</v-card-subtitle>
              </v-col>
              <v-col cols="4">
                <v-card-title class="comment-title">Comment</v-card-title>
                <v-dialog transition="scale-transition" origin="center center" max-width="554"
                  content-class="deposit-withdraw-popup" v-model="dialog2">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text elevation="0" class="text-capitalize pa-0 see-details-btn" v-bind="attrs" v-on="on">See
                      Details</v-btn>
                  </template>
                  <template>
                    <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                      <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'" @click="dialog2 = false" style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          z-index: 1;
                        ">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-card-title class="rounded-0">Comment</v-card-title>

                      <ol style="list-style-type: none">
                        <li>
                          Payments from third parties are not accepted. The name
                          of the sender must match the name on your trading
                          account.
                        </li>
                      </ol>
                    </v-card>
                  </template>
                </v-dialog>
              </v-col>
              <v-col cols="3">
                <v-card-title class="d-block">Status</v-card-title>
                <v-card-subtitle class="pending-text">Pending</v-card-subtitle>
              </v-col>
              <v-col cols="1">
                <v-dialog max-width="554" v-model="dialog">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn elevation="0" v-bind="attrs" v-on="on" class="icon-btn"><v-icon color="greenMain">mdi
                        mdi-file-image-outline</v-icon></v-btn>
                  </template>
                  <template>
                    <v-card class="rounded-0 bg-transparent" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                      <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'" @click="dialog = false" style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          z-index: 1;
                        ">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-img class="white--text align-end"
                        src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"></v-img>
                    </v-card>
                  </template>
                </v-dialog>
              </v-col>
            </v-row>
          </v-card>
          <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'" class="listing-upload">
            <v-row no-gutters justify="space-between" align="center">
              <v-col cols="4">
                <v-card-title>Date & Time</v-card-title>
                <v-card-subtitle>10/12-10:22pm</v-card-subtitle>
              </v-col>
              <v-col cols="4">
                <v-card-title class="comment-title">Comment</v-card-title>
                <v-dialog transition="scale-transition" origin="center center" max-width="554"
                  content-class="deposit-withdraw-popup" v-model="dialog3">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text elevation="0" class="text-capitalize pa-0 see-details-btn" v-bind="attrs" v-on="on">See
                      Details</v-btn>
                  </template>
                  <template>
                    <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                      <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'" @click="dialog3 = false" style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          z-index: 1;
                        ">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-card-title class="rounded-0">Comment</v-card-title>

                      <ol style="list-style-type: none">
                        <li>
                          Payments from third parties are not accepted. The name
                          of the sender must match the name on your trading
                          account.
                        </li>
                      </ol>
                    </v-card>
                  </template>
                </v-dialog>
              </v-col>
              <v-col cols="3">
                <v-card-title class="d-block">Status</v-card-title>
                <v-card-subtitle class="pending-text">Pending</v-card-subtitle>
              </v-col>
              <v-col cols="1">
                <v-dialog max-width="554" v-model="dialog4">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn elevation="0" v-bind="attrs" v-on="on" class="icon-btn"><v-icon color="greenMain">mdi
                        mdi-file-image-outline</v-icon></v-btn>
                  </template>
                  <template>
                    <v-card class="rounded-0 bg-transparent" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                      <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'" @click="dialog4 = false" style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          z-index: 1;
                        ">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-img class="white--text align-end"
                        src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"></v-img>
                    </v-card>
                  </template>
                </v-dialog>
              </v-col>
            </v-row>
          </v-card>
          <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'" class="listing-upload">
            <v-row no-gutters justify="space-between" align="center">
              <v-col cols="4">
                <v-card-title>Date & Time</v-card-title>
                <v-card-subtitle>10/12-10:22pm</v-card-subtitle>
              </v-col>
              <v-col cols="4">
                <v-card-title class="comment-title">Comment</v-card-title>
                <v-dialog transition="scale-transition" origin="center center" max-width="554"
                  content-class="deposit-withdraw-popup" v-model="dialog5">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text elevation="0" class="text-capitalize pa-0 see-details-btn" v-bind="attrs" v-on="on">See
                      Details</v-btn>
                  </template>
                  <template>
                    <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                      <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'" @click="dialog5 = false" style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          z-index: 1;
                        ">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-card-title class="rounded-0">Comment</v-card-title>

                      <ol style="list-style-type: none">
                        <li>
                          Payments from third parties are not accepted. The name
                          of the sender must match the name on your trading
                          account.
                        </li>
                      </ol>
                    </v-card>
                  </template>
                </v-dialog>
              </v-col>
              <v-col cols="3">
                <v-card-title class="d-block">Status</v-card-title>
                <v-card-subtitle class="pending-text">Pending</v-card-subtitle>
              </v-col>
              <v-col cols="1">
                <v-dialog max-width="554" v-model="dialog6">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn elevation="0" v-bind="attrs" v-on="on" class="icon-btn"><v-icon color="greenMain">mdi
                        mdi-file-image-outline</v-icon></v-btn>
                  </template>
                  <template>
                    <v-card class="rounded-0 bg-transparent" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                      <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'" @click="dialog6 = false" style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          z-index: 1;
                        ">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-img class="white--text align-end"
                        src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"></v-img>
                    </v-card>
                  </template>
                </v-dialog>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'" class="listing-upload">
            <v-row no-gutters justify="space-between" align="center">
              <v-col cols="4">
                <v-card-title>Date & Time</v-card-title>
                <v-card-subtitle>10/12-10:22pm</v-card-subtitle>
              </v-col>
              <v-col cols="4">
                <v-card-title class="comment-title">Comment</v-card-title>
                <v-dialog transition="scale-transition" origin="center center" max-width="554"
                  content-class="deposit-withdraw-popup" v-model="dialog7">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text elevation="0" class="text-capitalize pa-0 see-details-btn" v-bind="attrs" v-on="on">See
                      Details</v-btn>
                  </template>
                  <template>
                    <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                      <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'" @click="dialog7 = false" style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          z-index: 1;
                        ">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-card-title class="rounded-0">Comment</v-card-title>

                      <ol style="list-style-type: none">
                        <li>
                          Payments from third parties are not accepted. The name
                          of the sender must match the name on your trading
                          account.
                        </li>
                      </ol>
                    </v-card>
                  </template>
                </v-dialog>
              </v-col>
              <v-col cols="3">
                <v-card-title class="d-block">Status</v-card-title>
                <v-card-subtitle class="pending-text">Pending</v-card-subtitle>
              </v-col>
              <v-col cols="1">
                <v-dialog max-width="554" v-model="dialog8">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn elevation="0" v-bind="attrs" v-on="on" class="icon-btn"><v-icon color="greenMain">mdi
                        mdi-file-image-outline</v-icon></v-btn>
                  </template>
                  <template>
                    <v-card class="rounded-0 bg-transparent" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                      <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'" @click="dialog8 = false" style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          z-index: 1;
                        ">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-img class="white--text align-end"
                        src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"></v-img>
                    </v-card>
                  </template>
                </v-dialog>
              </v-col>
            </v-row>
          </v-card>
          <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'" class="listing-upload">
            <v-row no-gutters justify="space-between" align="center">
              <v-col cols="4">
                <v-card-title>Date & Time</v-card-title>
                <v-card-subtitle>10/12-10:22pm</v-card-subtitle>
              </v-col>
              <v-col cols="4">
                <v-card-title class="comment-title">Comment</v-card-title>
                <v-dialog transition="scale-transition" origin="center center" max-width="554"
                  content-class="deposit-withdraw-popup" v-model="dialog9">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text elevation="0" class="text-capitalize pa-0 see-details-btn" v-bind="attrs" v-on="on">See
                      Details</v-btn>
                  </template>
                  <template>
                    <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                      <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'" @click="dialog9 = false" style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          z-index: 1;
                        ">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-card-title class="rounded-0">Comment</v-card-title>

                      <ol style="list-style-type: none">
                        <li>
                          Payments from third parties are not accepted. The name
                          of the sender must match the name on your trading
                          account.
                        </li>
                      </ol>
                    </v-card>
                  </template>
                </v-dialog>
              </v-col>
              <v-col cols="3">
                <v-card-title class="d-block">Status</v-card-title>
                <v-card-subtitle class="pending-text">Pending</v-card-subtitle>
              </v-col>
              <v-col cols="1">
                <v-dialog max-width="554" v-model="dialog10">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn elevation="0" v-bind="attrs" v-on="on" class="icon-btn"><v-icon color="greenMain">mdi
                        mdi-file-image-outline</v-icon></v-btn>
                  </template>
                  <template>
                    <v-card class="rounded-0 bg-transparent" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                      <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'" @click="dialog10 = false" style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          z-index: 1;
                        ">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-img class="white--text align-end"
                        src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"></v-img>
                    </v-card>
                  </template>
                </v-dialog>
              </v-col>
            </v-row>
          </v-card>
          <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'" class="listing-upload">
            <v-row no-gutters justify="space-between" align="center">
              <v-col cols="4">
                <v-card-title>Date & Time</v-card-title>
                <v-card-subtitle>10/12-10:22pm</v-card-subtitle>
              </v-col>
              <v-col cols="4">
                <v-card-title class="comment-title">Comment</v-card-title>
                <v-dialog transition="scale-transition" origin="center center" max-width="554"
                  content-class="deposit-withdraw-popup" v-model="dialog11">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text elevation="0" class="text-capitalize pa-0 see-details-btn" v-bind="attrs" v-on="on">See
                      Details</v-btn>
                  </template>
                  <template>
                    <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                      <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'" @click="dialog11 = false" style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          z-index: 1;
                        ">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-card-title class="rounded-0">Comment</v-card-title>

                      <ol style="list-style-type: none">
                        <li>
                          Payments from third parties are not accepted. The name
                          of the sender must match the name on your trading
                          account.
                        </li>
                      </ol>
                    </v-card>
                  </template>
                </v-dialog>
              </v-col>
              <v-col cols="3">
                <v-card-title class="d-block">Status</v-card-title>
                <v-card-subtitle class="pending-text">Pending</v-card-subtitle>
              </v-col>
              <v-col cols="1">
                <v-dialog max-width="554" v-model="dialog12">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn elevation="0" v-bind="attrs" v-on="on" class="icon-btn"><v-icon color="greenMain">mdi
                        mdi-file-image-outline</v-icon></v-btn>
                  </template>
                  <template>
                    <v-card class="rounded-0 bg-transparent" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                      <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'" @click="dialog12 = false" style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          z-index: 1;
                        ">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-img class="white--text align-end"
                        src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"></v-img>
                    </v-card>
                  </template>
                </v-dialog>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { CLIENTS_DOCUMENTS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  name: "dropzoneView",
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      pdfImage: window.location.origin + "/static/images/pdf.png",
      dragging: false,
      dropzoneOptions: {
        acceptedFiles: "image/*",
        url: "https://httpbin.org/post",
        thumbnailWidth: 100,
        maxFilesize: 1024,
        headers: { "My-Awesome-Header": "header value" },
        maxFiles: 1,
        addRemoveLinks: true,
      },
      imageToPreview: "",
      dialog: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      dialog5: false,
      dialog6: false,
      dialog7: false,
      dialog8: false,
      dialog9: false,
      dialog10: false,
      dialog11: false,
      dialog12: false,
    };
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  computed: {
    ...mapState("clientsDocuments", ["documents"]),
  },
  methods: {
    ...mapActions("clientsDocuments", [
      CLIENTS_DOCUMENTS__ACTIONS.UPLOAD_DOCUMENTS,
    ]),

    identityVerificationFileUpload(file) {
      if (!file) {
        toast.error("Please select a file to upload!");
        this.$refs.identityVerification.removeFile(file);
        return;
      }

      if (file.size > 1024 * 1024) {
        toast.error("File size should be less than 1MB");
        this.$refs.identityVerification.removeFile(file);
        return;
      }

      // const allowedFileTypes = ["image/jpeg", "image/jpg", "image/png"];

      // if (!allowedFileTypes.includes(file.type)) {
      //   toast.error("Invalid file format. Upload JPG, JPEG, or PNG only.");
      //   this.$refs.identityVerification.removeFile(file);
      //   return;
      // }

      const formData = new FormData();
      formData.append("iFile", file);

      this[CLIENTS_DOCUMENTS__ACTIONS.UPLOAD_DOCUMENTS](formData);
    },

    residenceVerificationFileUpload(file) {
      if (!file) {
        toast.error("Please select a file to upload!");
        this.$refs.residenceVerification.removeFile(file);
        return;
      }

      if (file.size > 1024 * 1024) {
        toast.error("File size should be less than 1MB");
        this.$refs.residenceVerification.removeFile(file);
        return;
      }

      // const allowedFileTypes = ["image/jpeg", "image/jpg", "image/png"];

      // if (!allowedFileTypes.includes(file.type)) {
      //   toast.error("Invalid file format. Upload JPG, JPEG, or PNG only.");
      //   this.$refs.residenceVerification.removeFile(file);
      //   return;
      // }

      const formData = new FormData();
      formData.append("rFile", file);

      this[CLIENTS_DOCUMENTS__ACTIONS.UPLOAD_DOCUMENTS](formData);
    },
  },
};
</script>
